import React from 'react';
import styles from './StatCard.module.css';

const StatCard = ({ children }) => {
    return <div className={styles.statCard}>{children}</div>;
};

const Header = ({ children, icon }) => {
    return (
        <div className={styles.statHeader}>
            {icon && <i className={icon} />}
            {children}
        </div>
    );
};

const Value = ({ children }) => {
    return <div className={styles.statValue}>{children}</div>;
};

const Footer = ({ children }) => {
    return <div className={styles.statFooter}>{children}</div>;
};

const SuccessText = ({ children }) => {
    return <span className={styles.successText}>{children}</span>;
};

const DangerText = ({ children }) => {
    return <span className={styles.dangerText}>{children}</span>;
};

const WarningText = ({ children }) => {
    return <span className={styles.warningText}>{children}</span>;
};

StatCard.Header = Header;
StatCard.Value = Value;
StatCard.Footer = Footer;
StatCard.SuccessText = SuccessText;
StatCard.DangerText = DangerText;
StatCard.WarningText = WarningText;

export default StatCard;
